import styled from 'styled-components';
import BgImage from '../assets/images/guest/guest_bg.svg';


export const CenteredContainer = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  backgroundColor: theme.palette.background.default,

}));

export const CenteredGuestContainer = styled(CenteredContainer)(({ theme }) => ({
  backgroundImage: `url(${BgImage})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: '60%',
  justifyContent: 'center',
  gap: theme.spacing(8),
  alignItems: 'center',
  // padding: theme.spacing(8, 8.5)
}));


export const CenteredFormontainer = styled(CenteredContainer)(({ theme }) => ({
  height: "auto"
}));
